// extracted by mini-css-extract-plugin
module.exports = {"colourBlock":"ColourTable_colourBlock__12k5g","colourLabel":"ColourTable_colourLabel__h-QKl"};